import './CollapsibleCard.scss';
import { ReactNode, CSSProperties, useState, useEffect } from "react";

interface CollapsibleCardProps {
  title: string | ReactNode;
  subtitle?: string,
  children: ReactNode,
  noShadow?: boolean,
  style?: CSSProperties,
  onClick?: () => void,
  disabled?: boolean, //si está, deshabilita todas las opciones de una lista con excepción de la abierta
  isOpen?: boolean //si está, el estado de apertura se maneja desde afuera del componente. Si no está, se maneja internamente
}

export default function CollapsibleCard({ title, subtitle, children, noShadow = false, style = {}, onClick, disabled, isOpen: externalIsOpen }: Readonly<CollapsibleCardProps>) {
  const [internalIsOpen, setInternalIsOpen] = useState(false);

  const AngleDown = '/assets/angle-down.png';
  const cardStyle: React.CSSProperties = {
    boxShadow: noShadow ? '' : '0 4px 4px rgba(0,0,0,0.15)',
    opacity: disabled ? 0.5 : 1,
    pointerEvents: disabled ? 'none' : 'auto',
    ...style,
  };
  const isOpen = externalIsOpen ?? internalIsOpen;

  useEffect(() => { externalIsOpen !== undefined && setInternalIsOpen(externalIsOpen) }, [externalIsOpen]);

  const handleHeaderClick = () => {
    if (!disabled) {
      externalIsOpen === undefined && setInternalIsOpen(!internalIsOpen);
      onClick?.();
    }
  };

  return (
    <div className="collapsible-card" style={cardStyle}>
      <div className='content-header' onClick={handleHeaderClick}>
        <div className="header">
          <div className="title">{title}</div>
          <div className="subtitle">{subtitle}</div>
        </div>
        <div>
          <img src={AngleDown} alt="Angle" />
        </div>
      </div>
      {isOpen && <div className="content">{children}</div>}
    </div>);
};
